import { CJAtelier } from 'types/cj';

/**
 * Updates pending ephemeral groups across all ateliers.
 *
 * Behavior:
 * - Updates existing pending groups in all ateliers
 * - Adds new groups (not yet in any atelier) to the first atelier only
 * - This ensures new groups appear in rotation mode
 */
export function updatePendingEphemeralGroups(
  ateliers: CJAtelier[],
  updatedGroups: Array<{ id: string; elevesIds: string[] }>,
): CJAtelier[] {
  // Find which groups are new (not in any atelier yet)
  const existingIds = new Set<string>();
  ateliers.forEach(atelier => {
    (atelier.pendingEphemeralGroups || []).forEach(peg => {
      existingIds.add(peg.id);
    });
  });

  const newGroups = updatedGroups.filter(g => !existingIds.has(g.id));

  // Update all ateliers
  return ateliers.map((atelier, index) => {
    // Update existing pending groups
    const updatedPending = (atelier.pendingEphemeralGroups || []).map(peg => {
      const updated = updatedGroups.find(g => g.id === peg.id);
      return updated || peg;
    });

    // Add new groups to the first atelier only
    if (index === 0 && newGroups.length > 0) {
      return {
        ...atelier,
        pendingEphemeralGroups: [...updatedPending, ...newGroups],
      };
    }

    return {
      ...atelier,
      pendingEphemeralGroups: updatedPending,
    };
  });
}
